import { BREAKPOINT } from '@/modules/api'

const $ = require('jquery')

export function mapPropertiesConfig (url) {
  return $.ajax({
    type: 'get',
    url,
  })
}

/**
  * @return {JSON} - main json object with settings&regions data
  *
 **/
export function getJson (url) {
  return mapPropertiesConfig(url).then(function(response) {
    return response
  })
}

/**
  * @param {Object} - form data
  * @return {Object}
  *
 **/
export function getCenterCoords (json) {
  return {
    lat: parseFloat(json.Latitude),
    lng: parseFloat(json.Longitude),
  }
}

/**
  * @param {String} - JSON string - custom google map styles
  * @return {JSON}
  *
 **/
export function loadCustomMapStyles (styles) {
  /** Json comes from sitecore textarea field, so we need to remove unnecessary chars **/
  const clearJsonString = styles.replace(/<br \/>|&nbsp;|;| /gi, '')

  return JSON.parse(clearJsonString)
}

/**
  * @param {Function} - position of map
  * @param {Function} - map reference
  * @return {Function} - map marker
  *
 **/
export function getMarker (position, map, markerIcon) {
  const icon = markerIcon || mapMarkerIcon.regionActive

  return new google.maps.Marker({
    position,
    map,
    icon,
  })
}

/**
  * @param {Object} - activeRegion - selected region
  * @param {Number} - lat - map position Latitude
  * @param {Number} - lng - map position Longitude
  * @description - Set zoom and center position of selected region via marker or region slider.
  *
 **/
export function updateMapProperties (activeRegion, lat, lng) {
  globals.googleMapsMapReference.setCenter({ lat, lng })
  globals.googleMapsMapReference.setZoom(parseInt(activeRegion.Zoom))
}

/**
  * @param {Array} - mapMarkers - map markers list
  * @param {Object} - activeRegion
  *
 **/
export function handleMarkersIconOnRegionSelect (mapMarkers, activeRegion) {
  const self = this
  new google.maps.InfoWindow()

  /* "this" can be only an html node element or map marker item */
  const thisLat = typeof self.position === 'undefined' ? parseFloat($(self).attr('data-lat')) : self.position.lat()
  const thisLng = typeof self.position === 'undefined' ? parseFloat($(self).attr('data-lng')) : self.position.lng()

  mapMarkers.map(function(marker) {
    const itemLat = marker.position.lat()
    const itemLng = marker.position.lng()

    if (thisLat !== itemLat && thisLng !== itemLng) {
      marker.setIcon(mapMarkerIcon.regionInactive)
    } else {
      marker.setIcon(mapMarkerIcon.regionActive)
      updateMapProperties(activeRegion, thisLat, thisLng)
    }
  })
}

export const mapMarkerIcon = {
  defaults: '/assets/images/markerDefault.png',
  active: '/assets/images/markerActive.png',
  inactive: '/assets/images/markerInactive.png',
  regionActive: '/assets/images/markerRegionActive.png',
  regionInactive: '/assets/images/markerRegionInactive.png',
  franczyza: '/assets/images/Maps/Salesmap/map/franczyza.png',
  partner: '/assets/images/Maps/Salesmap/map/partner.png',
  wlasne: '/assets/images/Maps/Salesmap/map/wlasne.png',
}

/**
  * @param {Array} - mapMarkers - map markers list
  * @param {Object} - markerIcon - map marker icon
  * @return new replaced marker icon
  *
 **/
export function resetMapMarkers (mapMarkers, markerIcon) {
  const icon = markerIcon || mapMarkerIcon.regionActive
  mapMarkers.map(function(item) {
    return item.setIcon(icon)
  })
}

export function styleInfoWindow () {
  const $infowindowBg = $('.gm-style-iw').prev()
  const $infowindowCloseBtn = $('.gm-style-iw').next()

  $infowindowBg.parent().addClass('infowindowStyles')
  $infowindowBg.hide()
  $infowindowCloseBtn.hide()
}

/**
  * @param {Object} - mapDefaultSettings
  *
 **/
export function setDefaultMapPosition (mapDefaultSettings) {
  globals.googleMapsMapReference.setCenter({
    lat: parseFloat(mapDefaultSettings.Latitude),
    lng: parseFloat(mapDefaultSettings.Longitude),
  })

  globals.googleMapsMapReference.setZoom(parseInt(mapDefaultSettings.Zoom))
}

/**
 * @function for append loader
 * @param  {string} typeSize: set type loader ("big" or "small")
 * @param  {string} colorStyle: set color style ("whie" or "blue")
 * @param  {bolean} overlay: add load with overlay
 * @return {String}
 */
export const Loader = function(typeSize, colorStyle, overlay) {
  if (overlay) {
    return `
      <div class="loader-wrap">
        <div class="loader__inner loader--${colorStyle} loader__inner--${typeSize}">
          <div class="water-splash">
            <div>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>`
  } else {
    return `
      <div class="loader__inner loader--${colorStyle} loader__inner--${typeSize}">
        <div class="water-splash">
          <div>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>`
  }
}

export function isMobileView () {
  return window.innerWidth < BREAKPOINT.TABLET
}

export function isTabletView () {
  return window.innerWidth > BREAKPOINT.TABLET
}

export function isHomePage () {
  return document.body.classList.contains('page--home')
}

export function isMobileHomePage () {
  return window.innerWidth < BREAKPOINT.TABLET && isHomePage()
}

export function isDesktopHomePage () {
  return window.innerWidth >= BREAKPOINT.TABLET && isHomePage()
}

export function isListingPage () {
  return document.body.classList.contains('page--listing')  
}

export function isMobileListingPage () {
  return window.innerWidth < BREAKPOINT.TABLET && isListingPage()
}

export function isDesktopListingPage () {
  return window.innerWidth >= BREAKPOINT.TABLET && isListingPage()
}

export function isOfferPage () {
  return document.body.classList.contains('page--offer')
}

export function isPageWithNewSearcher () {
  return isHomePage() || isListingPage()
}

export const globals = {
  $MAP_WRAPPER: null,
  $MAP_WIDGET: null,
  infowindow: null,
  googleMapsMapReference: null,
  updateValueCallback: null,
}

export function isFluidLayoutPage () {
  return window.innerWidth < BREAKPOINT.TABLET && isPageWithNewSearcher()
}



// WEBPACK FOOTER //
// ./src/modules/globals.js